import React from 'react';
import { Clock3, ShieldCheck } from 'lucide-react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from './ui/alert-dialog';

const IdleWarningDialog = ({ open, secondsRemaining, onStaySignedIn }) => (
  <AlertDialog open={open}>
    <AlertDialogContent
      onEscapeKeyDown={(event) => event.preventDefault()}
      onPointerDownOutside={(event) => event.preventDefault()}
      data-testid="idle-session-warning-dialog"
    >
      <AlertDialogHeader>
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-amber-100 text-amber-800 sm:mx-0">
          <Clock3 className="h-6 w-6" />
        </div>
        <AlertDialogTitle>Your session is about to end</AlertDialogTitle>
        <AlertDialogDescription>
          You have been inactive. You will be signed out in <strong data-testid="idle-session-countdown">{secondsRemaining}</strong> seconds.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogAction onClick={onStaySignedIn} className="bg-green-700 hover:bg-green-800" data-testid="stay-signed-in-button">
          <ShieldCheck className="mr-2 h-4 w-4" /> Stay signed in
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export default IdleWarningDialog;